import {lifecycle, withProps} from 'recompose';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router';
import api, {getQuery} from 'api';
import {loadingIf} from 'ui';
import {equals, keys} from 'ramda';

const actionProps = new Set(['id', 'page', 'type', 'categoryId', 'path']);
const getActionData = props => {
  const data = [];
  keys(props).forEach(p => {
    if (actionProps.has(p)) {
      data[p] = props[p];
    }
  });
  return data;
};

const defaultPropsToRequestKey = ({type, id}) => {
  if (type && id) {
    return `${type}/${id}`;
  }
  return '';
};

export default (
    name,
    {loadingFullWidth, loadingHidden} = {},
    propsToRequestKey = defaultPropsToRequestKey,
  ) =>
  Component =>
    Component
    |> loadingIf(({loading, data}) => loading || !data, {
      loadingFullWidth: !!loadingFullWidth,
      loadingHidden: !!loadingHidden,
    })
    |> withProps(({fullname, ...props}) => {
      const {loading, data} = props[`${fullname}Data`];
      return {loading, data};
    })
    |> lifecycle({
      componentDidMount() {
        this.props[this.props.fullname](getActionData(this.props));
      },
      componentDidUpdate({fullname, ...prevProps}) {
        if (
          this.props.fullname !== fullname ||
          !equals(getActionData(this.props), getActionData(prevProps))
        ) {
          this.props[this.props.fullname](getActionData(this.props));
        }
      },
    })
    |> connect(
      (state, {action, fullname, ...props}) => ({
        [`${fullname}Data`]: getQuery(
          state,
          action,
          propsToRequestKey ? propsToRequestKey(props) : defaultPropsToRequestKey(props),
        ),
      }),
      (dispatch, {action, fullname}) => ({
        dispatch,
        ...bindActionCreators({[fullname]: action}, dispatch),
      }),
    )
    |> withProps(() => ({fullname: name, action: api[name]})) |>
    //|> withProps(({match}) => (match?.params ? {id: match.params?.id, page: match.params?.page} : {}))
    withRouter;
